import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a713945"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "education" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h2 class=\"title\" data-v-7a713945>Education and Coursework</h2><h3 class=\"school\" data-v-7a713945>Massachusetts Institute of Technology</h3><h4 class=\"degree\" data-v-7a713945>Masters of Engineering in <mark class=\"red\" data-v-7a713945>Electrical Engineering and Computer Science</mark></h4><h4 class=\"degree\" data-v-7a713945> Bachelor of Science in <mark class=\"red\" data-v-7a713945>Computer Science Engineering</mark> and <mark class=\"red\" data-v-7a713945>Bioengineering</mark></h4>", 4)
const _hoisted_6 = { class: "courses" }
const _hoisted_7 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_vue = _resolveComponent("icon-vue")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(_component_icon_vue, {
      color: 'red',
      icon: 'school'
    }),
    _hoisted_2,
    _createElementVNode("section", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classes, (cls, idx) => {
        return (_openBlock(), _createElementBlock("article", {
          key: cls.id,
          id: cls.id,
          class: _normalizeClass([...cls.tags, 'class', idx < 5 ? '' : idx < 10 ? 'top10' : idx < 20 ? 'top20' : 'all'])
        }, [
          _createElementVNode("h5", null, _toDisplayString(cls.name), 1),
          _createElementVNode("i", null, _toDisplayString(cls.id), 1)
        ], 10, _hoisted_7))
      }), 128))
    ])
  ]))
}